import React from 'react'
import s from './day-card.module.scss'
import classNames from 'classnames';
import { isToday } from 'date-fns';

export const DayCard = ({children, dayName, date, groupedTimeSlots, today, isTeacher, todayRef}) => {
	const weekday = date
		.toLocaleString("en-us", { weekday: "long" })
		.toLowerCase();
	const isNonWorking = groupedTimeSlots ? !groupedTimeSlots[weekday] : true

	const isTodayConst = isToday(date)

	const plusHour = (time) => {
		return +time.split(":")[0] + 1 + ":" + time.split(":")[1];
	};

	return (
		<div
			ref={isTodayConst ? todayRef : null}
			className={classNames(
				s.weekDay,
				isNonWorking && isTeacher ? s.nonworking : ""
			)}
		>
			<div className={s.weekDayHeader}>
				<div
					className={classNames(
						s.weekDayTitle,
						isTodayConst ? s.today : ""
					)}
				>
					{date.toLocaleString("ru-RU", {
						day: "numeric",
						month: "long",
					})}
					<span>{" " + dayName}</span>
				</div>
				{isTeacher ? (
					<div className={s.weekDayTimeRange}>
						{isNonWorking
							? "Выходной"
							: "Рабочее время " +
								groupedTimeSlots[weekday]?.from +
								"-" +
								plusHour(groupedTimeSlots[weekday]?.to)}
					</div>
				) : (
					""
				)}
			</div>
			<div className={s.hLine}></div>
			<div className={s.weekDayClasses}>
				{children}
			</div>
		</div>
	)
}
